function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import fetch from 'node-fetch';
import { searchFailed, searchInitiated, setSearchResults, updateCurrentPage, updateSortOrder } from '../actions/search';
import { updateUrl } from './updateUrl';
import { mapRawDataToAgent } from '../mappers/AgentMapper';
import { buildUrlQuery } from '../utils/QueryParamUtil';
import { generateSearchId } from '../utils/searchId';
import { trackEvent } from '../utils/tracking';
import { setTrackingSearchId } from '../actions/tracking';
import { getParameterByName } from '../utils/RestUtils';
import { resolveNearbyAgentSearch } from './nearbyAgents';
var reportSearchPagination = function reportSearchPagination(searchId, currentPage) {
  trackEvent({
    label: "agent_resultlist_search_".concat(searchId, "_pagination_").concat(currentPage),
    name: "search_pagination",
    parameter_1: "searchId_".concat(searchId),
    parameter_2: "page_".concat(currentPage)
  });
};
export var searchAgents = function searchAgents() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch, getState) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            dispatch(setSearchResults({
              pageResults: [],
              totalNumberOfPages: 0,
              currentPage: 1,
              totalNumberOfAgents: 0
            }));
            dispatch(setTrackingSearchId({
              searchId: generateSearchId()
            }));
            _context.n = 1;
            return resolveAgentSearch(dispatch, getState);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var updateCurrentPageNumber = function updateCurrentPageNumber(currentPage) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch, getState) {
      var state, newState;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            state = getState();
            dispatch(updateCurrentPage(_objectSpread(_objectSpread({}, state.search), {}, {
              currentPage: currentPage
            })));
            newState = getState();
            _context2.n = 1;
            return updateUrl()(dispatch, function () {
              return newState;
            });
          case 1:
            _context2.n = 2;
            return resolveAgentSearch(dispatch, getState);
          case 2:
            reportSearchPagination(state.tracking.searchId, currentPage);
          case 3:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};
export var onSortOrderChange = function onSortOrderChange(sorting) {
  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch, getState) {
      var state, newState;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            state = getState();
            dispatch(updateSortOrder(_objectSpread(_objectSpread({}, state.search), {}, {
              sorting: sorting
            })));
            newState = getState();
            _context3.n = 1;
            return updateUrl()(dispatch, function () {
              return newState;
            });
          case 1:
            _context3.n = 2;
            return resolveAgentSearch(dispatch, getState);
          case 2:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
};
export var onUrlChange = function onUrlChange() {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var pageNumber, order, sortBy, state, newState;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            pageNumber = getParameterByName('pagenumber') || '1';
            order = getParameterByName('sortorder');
            sortBy = getParameterByName('sortby');
            state = getState();
            if (pageNumber) {
              dispatch(updateCurrentPage(_objectSpread(_objectSpread({}, state.search), {}, {
                currentPage: parseInt(pageNumber)
              })));
            }
            newState = getState();
            if (order && sortBy) {
              dispatch(updateSortOrder(_objectSpread(_objectSpread({}, newState.search), {}, {
                sorting: {
                  sortBy: sortBy,
                  order: order
                }
              })));
            } else {
              dispatch(updateSortOrder(_objectSpread(_objectSpread({}, newState.search), {}, {
                sorting: undefined
              })));
            }
            _context4.n = 1;
            return resolveAgentSearch(dispatch, getState);
          case 1:
            window.scrollTo(0, 0);
          case 2:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};
function resolveAgentSearch(_x9, _x0) {
  return _resolveAgentSearch.apply(this, arguments);
}
function _resolveAgentSearch() {
  _resolveAgentSearch = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
    var _state$gacOverAllInfo, _state$gacOverAllInfo2, _state$search$sorting, _state$search$sorting2, state, shapeId, searchId, currentPage, apiEndpoint, type, sortBy, sortOrder, result, agentSearchResultData, hotSeat, totalNumberOfPages, totalNumberOfAgents, searchResult, _t;
    return _regenerator().w(function (_context5) {
      while (1) switch (_context5.p = _context5.n) {
        case 0:
          _context5.p = 0;
          dispatch(searchInitiated());
          state = getState(), shapeId = (_state$gacOverAllInfo = state.gacOverAllInfo) === null || _state$gacOverAllInfo === void 0 || (_state$gacOverAllInfo = _state$gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo === void 0 ? void 0 : _state$gacOverAllInfo.value;
          if (shapeId) {
            _context5.n = 1;
            break;
          }
          dispatch(searchFailed(true));
          return _context5.a(2);
        case 1:
          searchId = state.tracking.searchId, currentPage = state.search.currentPage, apiEndpoint = state.config.API_ENDPOINT, type = (_state$gacOverAllInfo2 = state.gacOverAllInfo.selectedSuggestion) === null || _state$gacOverAllInfo2 === void 0 ? void 0 : _state$gacOverAllInfo2.type, sortBy = (_state$search$sorting = state.search.sorting) === null || _state$search$sorting === void 0 ? void 0 : _state$search$sorting.sortBy, sortOrder = (_state$search$sorting2 = state.search.sorting) === null || _state$search$sorting2 === void 0 ? void 0 : _state$search$sorting2.order;
          _context5.n = 2;
          return fetchAgents(apiEndpoint, searchId, shapeId, currentPage, type, function () {
            return dispatch(searchFailed(true));
          }, sortBy, sortOrder);
        case 2:
          result = _context5.v;
          agentSearchResultData = mapRawDataToAgent(result.data.agentSearchResultData, state.config.DOMAIN);
          hotSeat = currentPage === 1 && result.data.hotSeat ? mapRawDataToAgent([result.data.hotSeat], state.config.DOMAIN)[0] : undefined;
          totalNumberOfPages = result.data.totalNumberOfPages || 0;
          totalNumberOfAgents = result.data.totalNumberOfAgents || 0;
          searchResult = {
            pageResults: agentSearchResultData,
            hotSeat: hotSeat,
            totalNumberOfPages: totalNumberOfPages,
            totalNumberOfAgents: totalNumberOfAgents
          };
          dispatch(searchFailed(false));
          if (!(totalNumberOfAgents > 0)) {
            _context5.n = 3;
            break;
          }
          dispatch(setSearchResults(searchResult));
          _context5.n = 4;
          break;
        case 3:
          _context5.n = 4;
          return resolveNearbyAgentSearch(dispatch, searchResult, apiEndpoint, shapeId, state.config.DOMAIN);
        case 4:
          _context5.n = 6;
          break;
        case 5:
          _context5.p = 5;
          _t = _context5.v;
          dispatch(searchFailed(true));
        case 6:
          return _context5.a(2);
      }
    }, _callee5, null, [[0, 5]]);
  }));
  return _resolveAgentSearch.apply(this, arguments);
}
function fetchAgents(_x1, _x10, _x11, _x12, _x13, _x14, _x15, _x16) {
  return _fetchAgents.apply(this, arguments);
}
function _fetchAgents() {
  _fetchAgents = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(apiEndpoint, searchId, shapeId, currentPage, type, onError, sortBy, sortOrder) {
    var parameters, url, response, error;
    return _regenerator().w(function (_context6) {
      while (1) switch (_context6.n) {
        case 0:
          parameters = {
            searchid: searchId,
            region: shapeId,
            pagenumber: currentPage,
            type: type,
            sortby: sortBy,
            sortOrder: sortOrder
          };
          url = "".concat(apiEndpoint, "/searchagents?").concat(buildUrlQuery(parameters));
          _context6.n = 1;
          return fetch(url);
        case 1:
          response = _context6.v;
          if (response.ok) {
            _context6.n = 2;
            break;
          }
          error = new Error("Could not fetch data. Status: ".concat(response.status));
          onError();
          console.log(error);
          return _context6.a(2);
        case 2:
          return _context6.a(2, response.json());
      }
    }, _callee6);
  }));
  return _fetchAgents.apply(this, arguments);
}